<template>
  <el-dialog
    v-model="dialogFormVisible"
    :title="title"
    width="500px"
    @close="close"
  >
    <el-form ref="form" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="会员等级" prop="levelId">
        <el-select v-model="form.levelId" placeholder="请选择会员等级">
          <el-option
            v-for="item in levels"
            :key="item.levelId"
            :label="item.title"
            :value="item.levelId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model.trim="form.name" :disabled="!!form.profileId" />
      </el-form-item>
      <el-form-item label="手机号" prop="tel">
        <el-input v-model.trim="form.tel" :disabled="!!form.profileId" />
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-radio v-model="form.sex" :label="1">先生</el-radio>
        <el-radio v-model="form.sex" :label="0">女士</el-radio>
      </el-form-item>
      <el-form-item label="生日" prop="birthday">
        <el-date-picker
          v-model="form.birthday"
          placeholder="选择日期"
          type="date"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item label="健康状态" prop="health">
        <el-radio v-model="form.health" :label="0">未知</el-radio>
        <el-radio v-model="form.health" :label="1">较差</el-radio>
        <el-radio v-model="form.health" :label="2">一般</el-radio>
        <el-radio v-model="form.health" :label="3">良好</el-radio>
      </el-form-item>
      <el-form-item label="客户经理" prop="salesPeopleId">
        <el-select v-model="form.salesPeopleId" placeholder="请选择员工">
          <el-option
            v-for="item in roles"
            :key="item.peopleId"
            :label="`${item.basic.name}（${item.basic.customId}）`"
            :value="item.peopleId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="渠道商" prop="agentId">
        <el-select v-model="form.agentId" placeholder="请选择渠道商">
          <el-option
            v-for="item in agents"
            :key="item.agentId"
            :label="`${item.title}`"
            :value="item.agentId"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { addProfile, editProfile, getAllLevels } from '@/api/people'
  import { getAllStaffs, } from '@/api/branch'

  export default {
    name: 'PeopleProfileEdit',
    emits: ['fetch-data'],
    data() {
      return {
        levels: [],
        roles: [],
        agents: [],
        form: {
          profileId: '',
          name: '',
          tel: '',
          sex: 1,
          birthday: '',
          health: 0,
          levelId: '',
          salesPeopleId: '',
          agentId: '',
        },
        rules: {
          levelId: [
            { required: true, trigger: 'blur', message: '请选择会员等级' },
          ],
          name: [{ required: true, trigger: 'blur', message: '请输入用户名' }],
          tel: [{ required: true, trigger: 'blur', message: '请输入手机号' }],
          sex: [{ required: true, trigger: 'blur', message: '请选择性别' }],
          birthday: [],
          health: [],
          salesPeopleId: [],
          agentId: [],
        },
        title: '',
        dialogFormVisible: false,
      }
    },
    methods: {
      async getLevels() {
        this.levels = await getAllLevels()
      },
      async getStaffs() {
        this.roles = await getAllStaffs()
      },
      showEdit(row) {
        if (!row) {
          this.title = '新增会员'
        } else {
          this.title = '修改会员'
          this.form = Object.assign(
            {},
            {
              profileId: row.profileId,
              name: row.name,
              tel: row.tel,
              sex: row.basic.sex,
              birthday: row.basic.birthday,
              health: row.basic.health,
              levelId: row.basic.levelId,
              salesPeopleId: row.basic.salesPeopleId,
              agentId: row.basic.agentId,
            }
          )
        }
        this.getLevels()
        this.getStaffs()
        this.dialogFormVisible = true
      },
      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            await (this.form.profileId
              ? editProfile(this.form)
              : addProfile(this.form))
            this.$baseMessage(
              this.form.profileId ? '修改会员成功' : '新增会员成功',
              'success',
              false,
              'vab-hey-message-success'
            )
            this.$emit('fetch-data')
            this.close()
          } else {
            return false
          }
        })
      },
    },
  }
</script>
